export const ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID = "xoyh4cWlDwocI9fTB2VT";
export const ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS = "Z0okHQdsAxp53nKHZLKI";
export const ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID = "GEIqpOgXvXI8roCGEqb5";
export const ARTICLE_MAIN_PAGE_ID = "t4HCqhSSbDsLSfl6bCVx";
export const ARTICLE_FISHMARKET = "rnDlDCxwMYfSYQZNiwhB";

export const EXCLUDED_IDS_FROM_MENU = [
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID,
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_IOS,
  ARTICLE_DEKLARACJA_DOSTEPNOSCI_ID_ANDROID,
  ARTICLE_MAIN_PAGE_ID,
  ARTICLE_FISHMARKET
]



// WEBPACK FOOTER //
// ./src/utils/config.js